<script setup lang="ts">
import FooterItem from '@fondof-ui/components/footer/FooterItem.vue'
import FooterMarkdownContent from '@fondof-ui/components/footer/FooterMarkdownContent.vue'
import FooterHeadline from '@satch-ui/components/footer/FooterHeadline.vue'
import type { FooterContentItem } from '@satch-ui/components/footer/types'
import { footerMarkdownVariants } from '@satch-ui/components/footer/variants'

const props = defineProps<FooterContentItem>()
</script>
<template>
  <div
    :data-cfid="props.id"
    class="row-start-6 md:col-start-[third-col] md:row-start-[third-row]"
  >
    <FooterItem disabled>
      <template #headline="{ disabled }">
        <FooterHeadline
          v-if="props.headline"
          :headline="props.headline"
          variant="primary"
          :disabled="disabled"
        />
      </template>
      <template #content>
        <FooterMarkdownContent
          data-size="large"
          :class="footerMarkdownVariants({ block: 'awards' })"
          :content="props.content"
        />
      </template>
    </FooterItem>
  </div>
</template>
